import React, { useEffect } from "react";
import {
  InnerContainer,
  MainContainer,
  MainHeading,
  RadioInnerWrapper,
  RadioWrapper,
  StyledCurrentAddress,
  StyledRadioButton,
} from "./styles";
import AddressForm from "../AddressForm";
import { useGetShippingAddressQuery } from "api/authApi";
import cache from "utils/cache";
import Loader from "shared/Loader";

const AddressPaymentDetails = ({ shippingSelection }) => {
  const {
    useDefaultShippingAddress,
    setUseDefaultShippingAddress,
    orderShippingAddress,
    setOrderShippingAddress,
    setHasSavedDefault,
  } = shippingSelection;

  const { data: shippingdetails, isLoading } = useGetShippingAddressQuery();
  const user = cache.getItem("user");
  const selectedValue = useDefaultShippingAddress ? "Current" : "New";

  useEffect(() => {
    const hasDefault = Boolean(shippingdetails?.streetAddress || shippingdetails?.city);
    setHasSavedDefault(hasDefault);
    if (!hasDefault && !isLoading) {
      setUseDefaultShippingAddress(false);
    }
  }, [shippingdetails, isLoading, setHasSavedDefault, setUseDefaultShippingAddress]);

  const handleRadioChange = (e) => {
    const next = e.target.value;
    setUseDefaultShippingAddress(next === "Current");
    if (next === "Current") {
      setOrderShippingAddress(null);
    }
  };

  const recipientFirst =
    shippingdetails?.firstName || user?.firstName || "";
  const recipientLast = shippingdetails?.lastName || user?.lastName || "";
  const recipientPhone =
    shippingdetails?.phoneNumber || user?.phoneNumber || "";

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <MainContainer>
          <InnerContainer>
            <MainHeading>{`Shipping Address`}</MainHeading>
            <RadioWrapper>
              <RadioInnerWrapper>
                <StyledRadioButton.Group
                  onChange={handleRadioChange}
                  value={selectedValue}
                >
                  <StyledRadioButton
                    value="Current"
                    disabled={!shippingdetails}
                  >
                    Use saved address
                  </StyledRadioButton>
                  <StyledRadioButton value="New">
                    Ship to a different address (this order only)
                  </StyledRadioButton>
                </StyledRadioButton.Group>
              </RadioInnerWrapper>

              <div style={{ marginTop: "20px" }}>
                {selectedValue === "Current" && shippingdetails && (
                  <>
                    <StyledCurrentAddress>{`${recipientFirst} ${recipientLast}`.trim()}</StyledCurrentAddress>
                    {recipientPhone && (
                      <StyledCurrentAddress>{recipientPhone}</StyledCurrentAddress>
                    )}
                    <StyledCurrentAddress>
                      {[
                        shippingdetails?.streetAddress,
                        shippingdetails?.apartmentNumber,
                        shippingdetails?.city,
                        shippingdetails?.state,
                        shippingdetails?.zip,
                        shippingdetails?.country,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </StyledCurrentAddress>
                  </>
                )}
                {selectedValue === "New" && (
                  <AddressForm
                    value={orderShippingAddress}
                    onChange={setOrderShippingAddress}
                  />
                )}
              </div>
            </RadioWrapper>
          </InnerContainer>
        </MainContainer>
      )}
    </>
  );
};

export default AddressPaymentDetails;
